import api from './axios';

/** Devuelve una URL firmada de S3 válida por 15 minutos. */
export async function presignUrl(url: string): Promise<string> {
  if (!url) return '';
  // Si no es S3 (URL legada local), devolver tal cual
  if (!url.includes('amazonaws.com')) return url;
  const res = await api.get('/api/storage/presign', {
    params: { url: encodeURIComponent(url) },
  });
  return res.data.url as string;
}

/** Descarga un archivo de S3 generando una URL firmada y simulando un click. */
export async function downloadS3File(url: string, filename: string): Promise<void> {
  const signed = await presignUrl(url);
  const a = document.createElement('a');
  a.href = signed;
  a.download = filename;
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/** Abre un archivo de S3 en una nueva pestaña con URL firmada. */
export async function openS3File(url: string): Promise<void> {
  const signed = await presignUrl(url);
  window.open(signed, '_blank', 'noopener noreferrer');
}
